<template>
  <div>
    <b-form-checkbox
      id="select-all-menu-network-permissions"
      v-model="allSelected"
      name="select-all-menu-network-permissions"
      class="text-capitalize mt-2"
      switch
    >
      {{ $t('hanwha_dvr.groups_permissions.select_all') }}
    </b-form-checkbox>
    <b-list-group>
      <b-list-group-item v-for="(option, index) in networkWithChildrenOptions" :key="index">
        <p class="h5 mb-1">{{ option.label }}</p>
        <div class="row">
          <div
            v-for="(optionChildren, indexChildren) in option.children"
            :key="indexChildren"
            class="col-6"
          >
            <b-form-checkbox
              :id="`option-children-${optionChildren.value}`"
              v-model="itemData.NetworkMenuAccess"
              :name="optionChildren.value"
              class="text-capitalize"
              switch
              :value="optionChildren.value"
            >
              {{ optionChildren.label }}
            </b-form-checkbox>
          </div>
        </div>
      </b-list-group-item>
      <b-list-group-item>
        <div class="row">
          <div
            v-for="(option, index) in networkWithoutChildrenOptions"
            :key="index"
            class="col-4"
          >
            <b-form-checkbox
              :id="`option-${option.value}`"
              v-model="itemData.NetworkMenuAccess"
              :name="option.value"
              class="text-capitalize"
              switch
              :value="option.value"
            >
              {{ option.label }}
            </b-form-checkbox>
          </div>
        </div>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import { useArraySelectAllSwitch, flattenOptionValues } from "./useSelectAllSwitch";

export default {
  props: {
    itemData: {
      type: Object
    }
  },
  setup (props) {
    //COMPOSABLES
    const { t } = useI18nUtils();

    //DATA
    const networkWithChildrenOptions = [
      {
        label: t('hanwha_dvr.groups_permissions.menu.network.ip_port'),
        children: [
          {
            label: t('hanwha_dvr.groups_permissions.menu.network.ip'),
            value: 'NetworkInterface'
          },
          {
            label: t('hanwha_dvr.groups_permissions.menu.network.port'),
            value: 'NetworkPort'
          }
        ],
      },
      {
        label: t('hanwha_dvr.groups_permissions.menu.network.email'),
        children: [
          {
            label: t('hanwha_dvr.groups_permissions.menu.network.event'),
            value: 'EventMail'
          },
          {
            label: t('hanwha_dvr.groups_permissions.menu.network.smtp'),
            value: 'SMTP'
          },
          {
            label: t('hanwha_dvr.groups_permissions.menu.network.recipient'),
            value: 'GroupAndRecipientEmail'
          }
        ],
      }
    ];

    const networkWithoutChildrenOptions = [
      {
        label: t('hanwha_dvr.groups_permissions.menu.network.ddns'),
        value: 'DDNS'
      },
      {
        label: t('hanwha_dvr.groups_permissions.menu.network.ip_filtering'),
        value: 'IPFilter'
      },
      {
        label: t('hanwha_dvr.groups_permissions.menu.network.https'),
        value: 'SSL'
      },
      {
        label: t('hanwha_dvr.groups_permissions.menu.network.8021'),
        value: '802.1x'
      },
      {
        label: t('hanwha_dvr.groups_permissions.menu.network.snmp'),
        value: 'SNMP'
      },
      {
        label: t('hanwha_dvr.groups_permissions.menu.network.dhcp'),
        value: 'DHCPServer'
      },
      {
        label: t('hanwha_dvr.groups_permissions.menu.network.p2p'),
        value: 'P2P'
      }
    ];

    const { allSelected } = useArraySelectAllSwitch(
      props.itemData,
      "NetworkMenuAccess",
      flattenOptionValues(networkWithChildrenOptions.concat(networkWithoutChildrenOptions))
    );

    return { allSelected, networkWithChildrenOptions, networkWithoutChildrenOptions }
  }
}
</script>
